import { TWhiteLabelStore } from '../white-label.model';

export function setIconActiveColorPanel(
  themeWrapper: HTMLBodyElement,
  whiteLabel: TWhiteLabelStore,
): void {
  themeWrapper.style.setProperty('--iconActiveColorPanel', whiteLabel.data.iconActiveColorPanel);
}
